namespace Newtonsoft.ViewModels.Contact {
    export class ContactViewModel {
        emailAddress = ko.observable<string>().extend({
            required: {
                params: true,
                message: "Your email address is required"
            }
        });
        emailSubject = ko.observable<string>().extend({
            required: {
                params: true,
                message: "An email subject is required"
            }
        });
        emailMessage = ko.observable<string>().extend({
            required: {
                params: true,
                message: "An email message is required"
            }
        });
        complete = ko.observable<boolean>();
        message = ko.observable<string>();
        validation: any;
        tokenHeader = ko.observable<string>();

        constructor(tokenHeader) {
            this.tokenHeader(tokenHeader);
            this.validation = ko.validatedObservable(this);
        }

        async sendEmail() {
            if (!this.validation.isValid()) {
                this.validation.errors.showAllMessages();
                return;
            }

            var json = JSON.stringify({
                emailAddress: this.emailAddress(),
                emailSubject: this.emailSubject(),
                emailMessage: this.emailMessage()
            });

            Newtonsoft.showLoading("body");

            try {
                const response = await fetch("/api/contact/sendemail", {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Csrf-Token': this.tokenHeader()
                    },
                    body: json
                });

                if (response.ok) {
                    this.message("Your email has been received.");
                    this.complete(true);
                } else {
                    await Newtonsoft.handleFailure(this, response);
                }
            } finally {
                Newtonsoft.hideLoading("body");
            }
        }
    }
}
